import axios, { AxiosRequestConfig } from "axios";
import config from "../../../../../config";
import { TAllowedCreateEntities } from "../models/entities/Shared";


export const sharedTableConfiguration = {
    quickFilter: true,
    selectiveQuickFilter: true,
    columnFilter: true,
    toggleColumns: true,
    multiSelect: true,
};
export const sharedColumnSettings = {
    resizable: true,
    searchInRender: true,
};

const host = `${config.api.internal}/AdministrationPanel`;
const reqConfig = { withCredentials: true } as AxiosRequestConfig;

//DATA
export const get = <T,>(path: string) => axios.get<T>(`${host}/${path}`, reqConfig).then((res) => res.data);

export const create = <T,>(path: string, newItem: TAllowedCreateEntities) => axios.post<T>(`${host}/${path}/Create`, newItem, reqConfig).then((res) => res.data);

export const edit = <T,>(ID: string | number | bigint, newValue: string | number | bigint | boolean | undefined, path: string, field: string) => axios.patch<T>(`${host}/${path}/${ID}/${field}/Edit`, { newValue }, reqConfig).then((res) => res.data);